import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../../node_modules/lit-element/node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`:host([isGroupsite]) .text-block{padding-bottom:60px;padding-top:60px}@media (min-width:1024px){:host([isGroupsite]) .text-block{justify-content:center}}:host([isGroupsite]) .text-block.align-center .content-container{max-width:1024px!important}:host([isGroupsite]) .media-container{margin-bottom:32px}@media (min-width:1024px){:host([isGroupsite]) .media-container{margin-bottom:0;max-width:35%}}`;

export { css_248z as default };
